import { Slide } from "@jelly/lesson";
import config from "appConfig";
import { task as task07 } from "../../../../../task/course-02/lesson-07/task-07";

const task: Slide = {
  titleHtml: `Determine the SPL value for a tone with f = 1 kHz and L<sub>N</sub> = 20 phon.`,
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/07/task/task-07.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task07.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
